import React from 'react';
import { FiExternalLink } from 'react-icons/fi';

const openClawUrl = new URL('../../assets/openclaw.png', import.meta.url).href;

const FeaturedIntegrations = ({ config }) => {
  return (
    <section aria-labelledby="integrations-heading" className="py-10 md:py-14 w-full">
      <div className="max-w-7xl mx-auto px-3 sm:px-6">
        {/* Section header */}
        <div className="text-center mb-8">
          <h2 id="integrations-heading" className="bg-gradient-to-r from-green-300 via-blue-500 to-purple-600 bg-clip-text text-transparent text-3xl sm:text-4xl lg:text-5xl font-extrabold">
            Ecosystem &amp; Integrations
          </h2> 
          <p className="text-gray-400 mt-2">
            Extend Katbot with powerful integrations
          </p>
        </div>

        {/* Single card — centred rather than stranded in a two-column grid */}
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-4 md:gap-6">
          {/* OpenClaw Card */}
          <a
            href={config.docsUrl + '/guides/openclaw-katbot-integration/'}
            target="_blank"
            rel="noopener noreferrer"
            className="group block no-underline"
          >
            <article className="bg-white/[0.03] backdrop-blur-sm border border-cyan-500/20 rounded-2xl p-4 sm:p-5 md:p-6 h-full hover:border-cyan-500/40 transition-all duration-300">
              <img
                src={openClawUrl}
                alt="OpenClaw Logo"
                className="h-30 mb-4 object-contain"
              />
              <h3 className="text-xl font-bold text-white mb-2">
                OpenClaw Agent Skill
              </h3>
              <p className="text-gray-400 text-lg leading-relaxed">
                Wire Katbot.ai to your OpenClaw agent in minutes. AI agents that can
                research, recommend, and execute perpetuals trades autonomously.
              </p>
              <span className="text-cyan-400 text-sm mt-3 inline-flex items-center gap-1 group-hover:gap-2 transition-all duration-200">
                Read the integration guide <FiExternalLink />
              </span>
            </article>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FeaturedIntegrations;
